<template>
  <div class="preservice-detail">
    <v-card class="preservice-detail-card" flat>
      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Full Name:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.firstName ? values.firstName : "-" }}
              {{ values.fatherName ? values.fatherName : "-" }}
              {{ values.grandFatherName ? values.grandFatherName : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Sex:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.sex ? values.sex : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">National ID (FAN):</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.idNo ? formatFanId(values.idNo) : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Background Profession:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values.backgroundProfession ? values.backgroundProfession : "-"
              }}
            </p>
          </div>
        </div>
      </v-card-text>

      <div class="preservice-detail-section-title title">
        Educational Information
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Department / Discipline:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.department ? values.department : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              {{ programEducationTypeLabel }}:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values?.educationProgram?.name
                  ? values.educationProgram.name
                  : "-"
              }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Level Of Study:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.levelOfStudy?.name ? values.levelOfStudy.name : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Year of Entry:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.entryYear ? values.entryYear : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Expected Graduation Year:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.expectedYear ? values.expectedYear : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Year of Graduation:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.graduationYear ? values.graduationYear : "-" }}
            </p>
          </div>
        </div>
      </v-card-text>

      <div class="preservice-detail-section-title title">
        About University
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Higher Learning Institution:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.university?.name ? values.university.name : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Ownership:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values?.university?.ownership?.name
                  ? values.university.ownership.name
                  : "-"
              }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Generation Level:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values?.university?.generation
                  ? values.university.generation
                  : "-"
              }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Region:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values?.university?.region?.name
                  ? values.university.region?.name
                  : "-"
              }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Town:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values?.university?.town ? values.university.town : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12"></div>
          <div class="w-1/2 h-12"></div>
        </div>
      </v-card-text>

      <div
        v-if="supportsStudentGradeTracking"
        class="preservice-detail-section-title title"
      >
        Student Grade Information
      </div>

      <v-card-text v-if="supportsStudentGradeTracking">
        <v-card
          class="flex flex-wrap my-2 mb-6"
          outlined
          style="background-color: whitesmoke"
        >
          <div class="w-full pb-0 md:mb-0">
            <v-simple-table class="preservice-status-history-table">
              <template v-if="studentStatusRows.length === 0" v-slot:no-data>
                NO DATA TO DISPLAY
              </template>
              <template v-else v-slot:default>
                <thead style="background-color: #e9ecee">
                  <tr>
                    <th width="5%">#</th>
                    <th class="text-left" width="20%">Year of Education</th>
                    <th class="text-left" width="20%">Student Status</th>
                    <th class="text-left" width="15%">GPA</th>
                    <th class="text-left" width="15%">Cumulative GPA</th>
                  </tr>
                </thead>
                <tbody style="background-color: whitesmoke">
                  <tr v-for="(item, index) in studentStatusRows" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.yearOfEducation || "-" }}</td>
                    <td>{{ item.studentStatus || "-" }}</td>
                    <td>{{ getDisplayGpa(item) }}</td>
                    <td>{{ getDisplayCumulativeGpa(item) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { formatFanId } from "@/utils/fan-id";
import { getStudentStatusGpaItems } from "@/utils/studentStatusGpa";

export default {
  props: {
    graduates: Object,
  },
  data() {
    return {
      values: [],
    };
  },
  computed: {
    isTvetProgram() {
      return this.values?.preServiceLevel === "TVETProgram";
    },
    isGraduateEntryProgram() {
      return this.values?.preServiceLevel === "NimeiProgram";
    },
    supportsStudentGradeTracking() {
      return (
        this.isTvetProgram ||
        this.isGraduateEntryProgram ||
        this.studentStatusRows.length > 0
      );
    },
    programEducationTypeLabel() {
      return "Program Education Type";
    },
    studentStatusRows() {
      return getStudentStatusGpaItems(this.values);
    },
  },
  created() {
    if (this.graduates != null) {
      this.values = this.graduates;
    }
  },
  methods: {
    formatFanId,
    getDisplayGpa(item) {
      return item?.gpa ?? "-";
    },
    getDisplayCumulativeGpa(item) {
      if (item?.cumulativeGpa != null) {
        return item.cumulativeGpa;
      }

      return "-";
    },
  },
};
</script>
